// useHeld — what is under the person's eyes is never swapped because a LIVE
// re-read stopped carrying it (ADR-075 §6 · FRONTEND-PATTERNS §Live updates).
//
// A surface shows ONE thing picked by id out of a list that re-reads itself in
// the background: the open photo of a flow, the review walk's photo.
// When that list no longer holds the id — someone else deleted the photo,
// answered it, closed the ticket — the surface must not vanish under a half-made
// answer: it keeps the last answer it had for THAT id, until the person moves on
// (the wanted id changes) or the thing comes back.
//
// State adjusted during render (React's own pattern for state derived from
// props) — never a ref read in render, never an effect that lags a frame.

import { useState } from 'react';

export function useHeld<T extends { id: string }>(found: T | null, wantedId: string | null): T | null {
  const [held, setHeld] = useState<T | null>(null);
  if (found ? held !== found : held !== null && held.id !== wantedId) setHeld(found);
  return found ?? (held !== null && held.id === wantedId ? held : null);
}
